/**
 * The media types currently supported by the movieXchange CDN.
 */
export var MoviexchangeMediaType;
(function (MoviexchangeMediaType) {
    /**
     * An advertising image for a Film.
     */
    MoviexchangeMediaType["FilmAdvertisement"] = "AdvertisingAndPromotions";
    /**
     * A banner image for a Film.
     */
    MoviexchangeMediaType["FilmBackdrop"] = "Backdrop";
    /**
     * An animated poster video for a Film.
     */
    MoviexchangeMediaType["FilmMotionPoster"] = "MotionPosters";
    /**
     * A poster image for a Film.
     */
    MoviexchangeMediaType["FilmPoster"] = "Poster";
    /**
     * A still image taken from a Film.
     */
    MoviexchangeMediaType["FilmStill"] = "Still";
    /**
     * An image of a stylised Film title.
     */
    MoviexchangeMediaType["FilmTitleTreatment"] = "TitleTreatment";
    /**
     * A full-length trailer for a Film.
     */
    MoviexchangeMediaType["FilmTrailer"] = "TrailerVideo";
    /**
     * An extended-length trailer for a Film.
     */
    MoviexchangeMediaType["FilmLongTrailer"] = "LongTrailer";
    /**
     * Production Notes for a Film.
     */
    MoviexchangeMediaType["FilmProductionNotes"] = "ProductionNotes";
    /**
     * Social Media assets for a Film.
     */
    MoviexchangeMediaType["FilmSocialMedia"] = "SocialMedia";
    /**
     * Web assets for a Film.
     */
    MoviexchangeMediaType["FilmWebMaterials"] = "WebMaterials";
    /**
     * Certification document for a Film.
     */
    MoviexchangeMediaType["FilmCertificate"] = "Certificate";
})(MoviexchangeMediaType || (MoviexchangeMediaType = {}));
//# sourceMappingURL=media-type.js.map